import { render } from "./ProximosTurnos.vue?vue&type=template&id=7e6f1fd9&ts=true"
import script from "./ProximosTurnos.vue?vue&type=script&lang=ts"
export * from "./ProximosTurnos.vue?vue&type=script&lang=ts"

import "./ProximosTurnos.vue?vue&type=style&index=0&id=7e6f1fd9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__